import React from "react";
import OfflinePlayer from "../components/OfflinePlayer";
import { connect } from "react-redux";

export class Offline extends React.Component {

  render() {
    const { featuredPlaylist } = this.props;
    return (
      <OfflinePlayer
        // selectedArtwork={0}
        history={this.props.history}
        // playlistName={featuredPlaylist.data.name}
        // artworks={featuredPlaylist.data.artworks}
        // hasSubscription={typeof this.props.subscription?.data?.plan?.id === 'string'}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  storeHistory: (history) => dispatch(storeHistory(history)),
});

export default connect(state => {
//   const { featuredPlaylist, subscription } = state;
//   return {
//     featuredPlaylist,
//     subscription,
//   };
}, mapDispatchToProps)(Offline);
